module.exports = __webpack_public_path__ + "img/portalbild23.5f119373.jpg";